const quizMeta = {
  hideBottomNavigation: true,
  hideAppBar: true,
  fullWidth: true,
  backgroundColor: "#080b0a",
}

export default [
  {
    path: "/quiz",
    name: "liveQuizLobby",
    component: () => import(/* webpackChunkName: "live-quiz" */ "@/views/quiz/LiveQuizLobby.vue"),
    meta: { ...quizMeta, rights: ["g_quiz"] },
  },
  {
    path: "/quiz/play/:sessionId",
    name: "liveQuizPlayer",
    component: () => import(/* webpackChunkName: "live-quiz" */ "@/views/quiz/LiveQuizPlayer.vue"),
    meta: { ...quizMeta, rights: ["g_quiz"] },
  },
  {
    path: "/quiz/manage",
    name: "liveQuizManage",
    component: () => import(/* webpackChunkName: "live-quiz-manage" */ "@/views/quiz/LiveQuizManage.vue"),
    meta: { ...quizMeta, rights: ["g_quizManage"] },
  },
  {
    path: "/quiz/host/:sessionId",
    name: "liveQuizHost",
    component: () => import(/* webpackChunkName: "live-quiz-host" */ "@/views/quiz/LiveQuizHost.vue"),
    meta: { ...quizMeta, rights: ["g_quizManage"] },
  },
]
